import { SpondGroup, SpondMatch, SpondPlayer } from '../models/Models';
import { set, get, del, keys, Store } from "idb-keyval";
import axios from 'axios';
import moment from "moment";

export class SpondService {
    private store: Store;

    constructor() {
        this.store = new Store('playmatch-db', 'spond-store');
    
        axios.defaults.responseType = 'json';
        axios.defaults.baseURL = 'https://playmatchapi.azurewebsites.net/api/spond'
    }

    public login(username: string, password: string): Promise<any> {        
        return axios.post('/login', {
            email: username,
            password: password
        })
        .then(async response => {
            const token = response.data.loginToken;          
            await set('spondToken', token, this.store);
        });
    }

    public async getGroups(): Promise<Array<SpondGroup>> {
        const spondToken = await get('spondToken', this.store);
        
        if (!spondToken || spondToken == '') {    
            throw 'no_token';
        }

        axios.defaults.headers.common['Authorization'] = spondToken;
        
        return axios.get('/groups')
            .then(async response => {
                const groups = response.data;
                return groups;
            })
            .catch(async err => {
                console.error('error from spond', err);
                await this.signout();
                throw err;
            });
    }

    public async setSelectedGroup(group: SpondGroup) {
        await set('spondGroup', group.id, this.store);
        await set('spondGroupName', group.name, this.store);    
    }

    public async getSelectedGroupName(): Promise<string> {
        const spondGroupName = (await get('spondGroupName', this.store)) as string;
        return spondGroupName;
    }

    public async getMatches(): Promise<Array<SpondMatch>> {
        const spondToken = await get('spondToken', this.store);    

        if (!spondToken || spondToken == '') {      
            throw 'no_token';
        }

        const spondGroup = await get('spondGroup', this.store);

        if (!spondGroup || spondGroup == '') {      
            throw 'no_group';
        }

        axios.defaults.headers.common['Authorization'] = spondToken;

        return axios.get('/sponds?groupId=' + spondGroup)
            .then(async response => {

                const matches = response.data;

                const matchKeys = await keys();

                for(const match of matches) {
                    if (matchKeys.find(x => x === match.id)) {
                        match.alreadyExistsPlaymatch = true;
                    }

                    if (match.startTimestamp) {
                        match.startTimestampLocale = moment.utc(match.startTimestamp).local().format('DD.MM.YYYY HH:mm');
                    }          
                }

                return matches;
            })
            .catch(async err => {
                console.error('error from spond', err);
                await this.signout();
                throw err;
            });
    }

    public async signout() {
        await del('spondGroup', this.store);
        await del('spondGroupName', this.store);    
        await del('spondToken', this.store);        
    }
}

export default new SpondService();